const contextPath = "/";

const apiPath = "/api";

const xsrfCookieName = "XSRF-TOKEN";
const xsrfParameterName = "_csrf";
const xsrfHeaderName = "X-XSRF-TOKEN";

const environmentFromHostname =
    window.location.hostname === "mtn-tv-automation.mtn.com"
    ? "production"
    : window.location.hostname === "mtn-tv-automation.mtn.southerncross.cloud"
      ? "staging"
      : "development";

const configByEnvironment =
    {
        "production": {
            webSocketEnabled: false,
            webSocketBaseUrl: "wss://mtn-tv-automation.mtn.com/ws",
        },
        "staging": {
            webSocketEnabled: false,
            webSocketBaseUrl: "wss://mtn-tv-automation.mtn.southerncross.cloud/ws",
        },
        "development": {
            webSocketEnabled: false,
            webSocketBaseUrl: "ws://localhost:8080/ws",
        },
    };

const config = configByEnvironment[environmentFromHostname];

const toCountryName = (iso3116_3CountryCode?: string): string => {
    switch (iso3116_3CountryCode) {
        case "ABW": return "Aruba";
        case "AFG": return "Afghanistan";
        case "AGO": return "Angola";
        case "AIA": return "Anguilla";
        case "ALB": return "Albania";
        case "AND": return "Andorra";
        case "ANT": return "Netherlands Antilles";
        case "ARE": return "United Arab Emirates";
        case "ARG": return "Argentina";
        case "ARM": return "Armenia";
        case "ASM": return "American Samoa";
        case "ATA": return "Antarctica";
        case "ATG": return "Antigua and Barbuda";
        case "AUS": return "Australia";
        case "AUT": return "Austria";
        case "AZE": return "Azerbaijan";
        case "BDI": return "Burundi";
        case "BEL": return "Belgium";
        case "BEN": return "Benin";
        case "BFA": return "Burkina Faso";
        case "BGD": return "Bangladesh";
        case "BGR": return "Bulgaria";
        case "BHR": return "Bahrain";
        case "BHS": return "Bahamas";
        case "BIH": return "Bosnia and Herzegovina";
        case "BLM": return "Saint Barthelemy";
        case "BLR": return "Belarus";
        case "BLZ": return "Belize";
        case "BMU": return "Bermuda";
        case "BOL": return "Bolivia";
        case "BRA": return "Brazil";
        case "BRB": return "Barbados";
        case "BRN": return "Brunei";
        case "BTN": return "Bhutan";
        case "BWA": return "Botswana";
        case "CAF": return "Central African Republic";
        case "CAN": return "Canada";
        case "CCK": return "Cocos Islands";
        case "CHE": return "Switzerland";
        case "CHL": return "Chile";
        case "CHN": return "China";
        case "CIV": return "Ivory Coast";
        case "CMR": return "Cameroon";
        case "COD": return "Democratic Republic of the Congo";
        case "COG": return "Republic of the Congo";
        case "COK": return "Cook Islands";
        case "COL": return "Colombia";
        case "COM": return "Comoros";
        case "CPV": return "Cape Verde";
        case "CRI": return "Costa Rica";
        case "CUB": return "Cuba";
        case "CUW": return "Curacao";
        case "CXR": return "Christmas Island";
        case "CYM": return "Cayman Islands";
        case "CYP": return "Cyprus";
        case "CZE": return "Czech Republic";
        case "DEU": return "Germany";
        case "DJI": return "Djibouti";
        case "DMA": return "Dominica";
        case "DNK": return "Denmark";
        case "DOM": return "Dominican Republic";
        case "DZA": return "Algeria";
        case "ECU": return "Ecuador";
        case "EGY": return "Egypt";
        case "ERI": return "Eritrea";
        case "ESH": return "Western Sahara";
        case "ESP": return "Spain";
        case "EST": return "Estonia";
        case "ETH": return "Ethiopia";
        case "FIN": return "Finland";
        case "FJI": return "Fiji";
        case "FLK": return "Falkland Islands";
        case "FRA": return "France";
        case "FRO": return "Faroe Islands";
        case "FSM": return "Micronesia";
        case "GAB": return "Gabon";
        case "GBR": return "United Kingdom";
        case "GEO": return "Georgia";
        case "GGY": return "Guernsey";
        case "GHA": return "Ghana";
        case "GIB": return "Gibraltar";
        case "GIN": return "Guinea";
        case "GMB": return "Gambia";
        case "GNB": return "Guinea-Bissau";
        case "GNQ": return "Equatorial Guinea";
        case "GRC": return "Greece";
        case "GRD": return "Grenada";
        case "GRL": return "Greenland";
        case "GTM": return "Guatemala";
        case "GUM": return "Guam";
        case "GUY": return "Guyana";
        case "HKG": return "Hong Kong";
        case "HND": return "Honduras";
        case "HRV": return "Croatia";
        case "HTI": return "Haiti";
        case "HUN": return "Hungary";
        case "IDN": return "Indonesia";
        case "IMN": return "Isle of Man";
        case "IND": return "India";
        case "IOT": return "British Indian Ocean Territory";
        case "IRL": return "Ireland";
        case "IRN": return "Iran";
        case "IRQ": return "Iraq";
        case "ISL": return "Iceland";
        case "ISR": return "Israel";
        case "ITA": return "Italy";
        case "JAM": return "Jamaica";
        case "JEY": return "Jersey";
        case "JOR": return "Jordan";
        case "JPN": return "Japan";
        case "KAZ": return "Kazakhstan";
        case "KEN": return "Kenya";
        case "KGZ": return "Kyrgyzstan";
        case "KHM": return "Cambodia";
        case "KIR": return "Kiribati";
        case "KNA": return "Saint Kitts and Nevis";
        case "KOR": return "South Korea";
        case "KWT": return "Kuwait";
        case "LAO": return "Laos";
        case "LBN": return "Lebanon";
        case "LBR": return "Liberia";
        case "LBY": return "Libya";
        case "LCA": return "Saint Lucia";
        case "LIE": return "Liechtenstein";
        case "LKA": return "Sri Lanka";
        case "LSO": return "Lesotho";
        case "LTU": return "Lithuania";
        case "LUX": return "Luxembourg";
        case "LVA": return "Latvia";
        case "MAC": return "Macau";
        case "MAF": return "Saint Martin";
        case "MAR": return "Morocco";
        case "MCO": return "Monaco";
        case "MDA": return "Moldova";
        case "MDG": return "Madagascar";
        case "MDV": return "Maldives";
        case "MEX": return "Mexico";
        case "MHL": return "Marshall Islands";
        case "MKD": return "Macedonia";
        case "MLI": return "Mali";
        case "MLT": return "Malta";
        case "MMR": return "Myanmar";
        case "MNE": return "Montenegro";
        case "MNG": return "Mongolia";
        case "MNP": return "Northern Mariana Islands";
        case "MOZ": return "Mozambique";
        case "MRT": return "Mauritania";
        case "MSR": return "Montserrat";
        case "MUS": return "Mauritius";
        case "MWI": return "Malawi";
        case "MYS": return "Malaysia";
        case "MYT": return "Mayotte";
        case "NAM": return "Namibia";
        case "NCL": return "New Caledonia";
        case "NER": return "Niger";
        case "NGA": return "Nigeria";
        case "NIC": return "Nicaragua";
        case "NIU": return "Niue";
        case "NLD": return "Netherlands";
        case "NOR": return "Norway";
        case "NPL": return "Nepal";
        case "NRU": return "Nauru";
        case "NZL": return "New Zealand";
        case "OMN": return "Oman";
        case "PAK": return "Pakistan";
        case "PAN": return "Panama";
        case "PCN": return "Pitcairn";
        case "PER": return "Peru";
        case "PHL": return "Philippines";
        case "PLW": return "Palau";
        case "PNG": return "Papua New Guinea";
        case "POL": return "Poland";
        case "PRI": return "Puerto Rico";
        case "PRK": return "North Korea";
        case "PRT": return "Portugal";
        case "PRY": return "Paraguay";
        case "PSE": return "Palestine";
        case "PYF": return "French Polynesia";
        case "QAT": return "Qatar";
        case "REU": return "Reunion";
        case "ROU": return "Romania";
        case "RUS": return "Russia";
        case "RWA": return "Rwanda";
        case "SAU": return "Saudi Arabia";
        case "SDN": return "Sudan";
        case "SEN": return "Senegal";
        case "SGP": return "Singapore";
        case "SHN": return "Saint Helena";
        case "SJM": return "Svalbard and Jan Mayen";
        case "SLB": return "Solomon Islands";
        case "SLE": return "Sierra Leone";
        case "SLV": return "El Salvador";
        case "SMR": return "San Marino";
        case "SOM": return "Somalia";
        case "SPM": return "Saint Pierre and Miquelon";
        case "SRB": return "Serbia";
        case "SSD": return "South Sudan";
        case "STP": return "Sao Tome and Principe";
        case "SUR": return "Suriname";
        case "SVK": return "Slovakia";
        case "SVN": return "Slovenia";
        case "SWE": return "Sweden";
        case "SWZ": return "Swaziland";
        case "SXM": return "Sint Maarten";
        case "SYC": return "Seychelles";
        case "SYR": return "Syria";
        case "TCA": return "Turks and Caicos Islands";
        case "TCD": return "Chad";
        case "TGO": return "Togo";
        case "THA": return "Thailand";
        case "TJK": return "Tajikistan";
        case "TKL": return "Tokelau";
        case "TKM": return "Turkmenistan";
        case "TLS": return "East Timor";
        case "TON": return "Tonga";
        case "TTO": return "Trinidad and Tobago";
        case "TUN": return "Tunisia";
        case "TUR": return "Turkey";
        case "TUV": return "Tuvalu";
        case "TWN": return "Taiwan";
        case "TZA": return "Tanzania";
        case "UGA": return "Uganda";
        case "UKR": return "Ukraine";
        case "URY": return "Uruguay";
        case "USA": return "United States";
        case "UZB": return "Uzbekistan";
        case "VAT": return "Vatican";
        case "VCT": return "Saint Vincent and the Grenadines";
        case "VEN": return "Venezuela";
        case "VGB": return "British Virgin Islands";
        case "VIR": return "U.S. Virgin Islands";
        case "VNM": return "Vietnam";
        case "VUT": return "Vanuatu";
        case "WLF": return "Wallis and Futuna";
        case "WSM": return "Samoa";
        case "XKX": return "Kosovo";
        case "YEM": return "Yemen";
        case "RSA": return "South Africa";
        case "ZAF": return "South Africa";
        case "ZMB": return "Zambia";
        case "ZWE": return "Zimbabwe";
        default: return iso3116_3CountryCode?.toUpperCase() ?? "";
    }
};

const toLanguageName = (iso369_languageCode?: string): string => {
    switch (iso369_languageCode) {
        case "abk": return "Abkhazian";
        case "aar": return "Afar";
        case "afr": return "Afrikaans";
        case "aka": return "Akan";
        case "sqi": return "Albanian";
        case "amh": return "Amharic";
        case "ara": return "Arabic";
        case "arg": return "Aragonese";
        case "hye": return "Armenian";
        case "asm": return "Assamese";
        case "ava": return "Avaric";
        case "ave": return "Avestan";
        case "aym": return "Aymara";
        case "aze": return "Azerbaijani";
        case "bam": return "Bambara";
        case "bak": return "Bashkir";
        case "eus": return "Basque";
        case "bel": return "Belarusian";
        case "bem": return "Bemba";
        case "ben": return "Bengali";
        case "bis": return "Bislama";
        case "bos": return "Bosnian";
        case "bre": return "Breton";
        case "bul": return "Bulgarian";
        case "mya": return "Burmese";
        case "cat": return "Catalan";
        case "cha": return "Chamorro";
        case "che": return "Chechen";
        case "zho": return "Chinese";
        case "toi": return "Chitonga";
        case "chu": return "Church Slavonic";
        case "chv": return "Chuvash";
        case "cor": return "Cornish";
        case "cos": return "Corsican";
        case "cre": return "Cree";
        case "hrv": return "Croatian";
        case "ces": return "Czech";
        case "dan": return "Danish";
        case "div": return "Divehi";
        case "nld": return "Dutch";
        case "dzo": return "Dzongkha";
        case "eng": return "English";
        case "epo": return "Esperanto";
        case "est": return "Estonian";
        case "ewe": return "Ewe";
        case "fao": return "Faroese";
        case "fij": return "Fijian";
        case "fin": return "Finnish";
        case "fra": return "French";
        case "fry": return "Western Frisian";
        case "ful": return "Fulah";
        case "gla": return "Gaelic";
        case "glg": return "Galician";
        case "lug": return "Ganda";
        case "kat": return "Georgian";
        case "deu": return "German";
        case "ell": return "Greek";
        case "kal": return "Kalaallisut";
        case "grn": return "Guarani";
        case "guj": return "Gujarati";
        case "hat": return "Haitian";
        case "hau": return "Hausa";
        case "heb": return "Hebrew";
        case "her": return "Herero";
        case "hin": return "Hindi";
        case "hmo": return "Hiri Motu";
        case "hun": return "Hungarian";
        case "isl": return "Icelandic";
        case "ido": return "Ido";
        case "ibo": return "Igbo";
        case "ind": return "Indonesian";
        case "ina": return "Interlingua";
        case "ile": return "Interlingue";
        case "iku": return "Inuktitut";
        case "ipk": return "Inupiaq";
        case "gle": return "Irish";
        case "ita": return "Italian";
        case "jpn": return "Japanese";
        case "jav": return "Javanese";
        case "kan": return "Kannada";
        case "kau": return "Kanuri";
        case "kas": return "Kashmiri";
        case "kaz": return "Kazakh";
        case "khm": return "Central Khmer";
        case "kik": return "Kikuyu";
        case "kin": return "Kinyarwanda";
        case "kir": return "Kyrgyz";
        case "kom": return "Komi";
        case "kon": return "Kongo";
        case "kor": return "Korean";
        case "kua": return "Kuanyama";
        case "kur": return "Kurdish";
        case "lao": return "Lao";
        case "lat": return "Latin";
        case "lav": return "Latvian";
        case "lim": return "Limburgan";
        case "lin": return "Lingala";
        case "lit": return "Lithuanian";
        case "lub": return "Luba-Katanga";
        case "ltz": return "Luxembourgish";
        case "mkd": return "Macedonian";
        case "mlg": return "Malagasy";
        case "msa": return "Malay";
        case "mal": return "Malayalam";
        case "mlt": return "Maltese";
        case "glv": return "Manx";
        case "mri": return "Maori";
        case "mar": return "Marathi";
        case "mah": return "Marshallese";
        case "mon": return "Mongolian";
        case "nau": return "Nauru";
        case "nav": return "Navajo";
        case "nde": return "North Ndebele";
        case "nbl": return "South Ndebele";
        case "ndo": return "Ndonga";
        case "nep": return "Nepali";
        case "nor": return "Norwegian";
        case "nob": return "Norwegian Bokmål";
        case "nno": return "Norwegian Nynorsk";
        case "nya": return "Nyanja";
        case "oci": return "Occitan";
        case "oji": return "Ojibwa";
        case "ori": return "Oriya";
        case "orm": return "Oromo";
        case "oss": return "Ossetian";
        case "pli": return "Pali";
        case "pus": return "Pashto";
        case "fas": return "Persian";
        case "pol": return "Polish";
        case "por": return "Portuguese";
        case "pan": return "Punjabi";
        case "que": return "Quechua";
        case "ron": return "Romanian";
        case "roh": return "Romansh";
        case "run": return "Rundi";
        case "rus": return "Russian";
        case "sme": return "Northern Sami";
        case "smo": return "Samoan";
        case "sag": return "Sango";
        case "san": return "Sanskrit";
        case "srd": return "Sardinian";
        case "srp": return "Serbian";
        case "sna": return "Shona";
        case "snd": return "Sindhi";
        case "sin": return "Sinhala";
        case "slk": return "Slovak";
        case "slv": return "Slovenian";
        case "som": return "Somali";
        case "sot": return "Southern Sotho";
        case "spa": return "Spanish";
        case "sun": return "Sundanese";
        case "swa": return "Swahili";
        case "ssw": return "Swati";
        case "swe": return "Swedish";
        case "tgl": return "Tagalog";
        case "tah": return "Tahitian";
        case "tgk": return "Tajik";
        case "tam": return "Tamil";
        case "tat": return "Tatar";
        case "tel": return "Telugu";
        case "tha": return "Thai";
        case "bod": return "Tibetan";
        case "tir": return "Tigrinya";
        case "ton": return "Tonga";
        case "tso": return "Tsonga";
        case "tsn": return "Tswana";
        case "tur": return "Turkish";
        case "tuk": return "Turkmen";
        case "twi": return "Twi";
        case "uig": return "Uighur";
        case "ukr": return "Ukrainian";
        case "urd": return "Urdu";
        case "uzb": return "Uzbek";
        case "ven": return "Venda";
        case "vie": return "Vietnamese";
        case "vol": return "Volapük";
        case "wln": return "Walloon";
        case "cym": return "Welsh";
        case "wol": return "Wolof";
        case "xho": return "Xhosa";
        case "iii": return "Sichuan Yi";
        case "yid": return "Yiddish";
        case "yor": return "Yoruba";
        case "zha": return "Zhuang";
        case "zul": return "Zulu";
        default: return iso369_languageCode?.toUpperCase() ?? "";
    }
};

export {
    contextPath,
    apiPath,
    xsrfCookieName,
    xsrfParameterName,
    xsrfHeaderName,
    config,
    toCountryName,
    toLanguageName,
};